<form [formGroup]="UPI_FORM">
    <section class="upi_section">
        <div class="wrapperInner">
            <h4>Enter UPI ID</h4>
            <mat-form-field appearance="outline" floatLabel="always" color="primary" class="col-md-12">
                <mat-label>Enter UPI Id</mat-label>
                <input matInput placeholder="Enter UPI Id" formControlName="upi_banking_number" maxlength="35">
                <mat-error *ngIf="UPI_FORM.controls['upi_banking_number'].hasError('required')"><strong>UPI Id</strong> is required.</mat-error>
                <mat-error *ngIf="UPI_FORM.controls['upi_banking_number'].hasError('pattern')"><strong>UPI Id</strong> is not Valid.</mat-error>
            </mat-form-field>
            <div class="more_information">
                <ul>
                    <li>Enter your registered VPA.</li>
                    <li>Receive payment request on bank app.</li>
                    <li>Authorize payment request.</li>
                </ul>
            </div>
        </div>
    </section>
</form>
<!-- {{ data | json }} -->